<template>
  <van-tabbar @change="change" v-show="showTabBar && !isApp" v-model="active" style="z-index: 12">
    <van-tabbar-item >
      <img class="nav-img" v-if="active==0" src="../assets/images/nav/icon-homepage-red1@2x.png" alt="">
      <img class="nav-img" v-else src="../assets/images/nav/icon-homepage-grey1@2x.png" alt="">
      首页</van-tabbar-item>
     
    <van-tabbar-item >
      <img class="nav-img" v-if="active==1" src="../assets/images/nav/icon-homepage-red3@2x.png" alt="">
      <img class="nav-img" v-else src="../assets/images/nav/icon-homepage-grey3@2x.png" alt="">
      活动</van-tabbar-item>
      
    <van-tabbar-item >
      <img class="nav-img" v-if="active==2" src="../assets/images/nav/icon-homepage-red5@2x.png" alt="">
      <img class="nav-img" v-else src="../assets/images/nav/icon-homepage-grey5@2x.png" alt="">
      我的</van-tabbar-item>
  </van-tabbar>
</template>
<style scope>
  .van-tabbar-item--active{color: #FD2840 !important;}

  .van-tabbar-item__icon {
    font-size: 22px;
  }
  .van-tabbar-item__text{display: flex;flex-direction: column;}
  .nav-img{width: 22px;height: 22px;margin-bottom: 5px;}
</style>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar).use(TabbarItem);
export default {
  name: 'TabBar',
  props: ['showTabBar','currentTab'],
  data() {
    return {
      active: 0,
      isApp: isApp()? true: false
    }
  },
  mounted:function () {
    switch (this.$route.name){
      case 'Index':
        this.active = 0;
        console.log(this.active)
        ;break;
      case 'Activity':
        this.active = 1; 
        ;break;
      case 'MineIndex':
        this.active = 2; break;
       
    }
  },
  methods:{
    change:function (index) {
      switch (index){
        case 0 : this.$router.push({
          'name':'Index'
          // 'name':'goodsList'
        });break;
        case 1 : this.$router.push({
          'name':'Activity'
        });break;
        case 2 : this.$router.push({
          'name':'MineIndex'
        });break;
         
      } 
    }
  }
}
</script>



// WEBPACK FOOTER //
// TabBar.vue?6c6fa0b9